export default __webpack_public_path__ + "static/structural7-de0d6ba89bc681a373dcdad6ed906630.png";